export const RootUserGuideRoutes = {
  Home: '',
  GettingStarted: 'getting-started',
  FeatureGuide: 'feature-guide',
  Tutorials: 'tutorials',
  FAQ: 'faq',
};
